import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Navbar.css';
import logo from '../assets/images/logo.png'
import LanguageSwitcher from './LanguageSwitcher';
import { useTranslation } from 'react-i18next';


export default function Navbar() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const { t } = useTranslation();
    const location = useLocation();
    const alwaysFixedRoutes = ['/checkout', '/impressum', '/datenschutz', '/agb'];
    const isFixedPage = alwaysFixedRoutes.includes(location.pathname);


    const handleScroll = () => {
        // If scrolled 100px or more, set isScrolled to true
        if (window.scrollY > 100) {
            setIsScrolled(true);
        } else {
            setIsScrolled(false);
        }
    };

    useEffect(() => {
        // Add scroll event listener
        window.addEventListener('scroll', handleScroll);

        // Cleanup on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <nav className={`navbar ${isScrolled || isFixedPage ? 'scrolled' : 'transparent'}`}>
            <div className="navbar-container">
                <a href="/" className="logo">
                    <img src={logo} alt="HELLO CHARGE Logo" className='logo-img' />
                </a>
                {/* Hamburger Menu - MOBILE ONLY */}
                <div className={`hamburger ${isMenuOpen ? 'active' : ''}`} onClick={() => setIsMenuOpen(!isMenuOpen)}>
                    <div className="hamburger-line"></div>
                    <div className="hamburger-line"></div>
                    <div className="hamburger-line"></div>
                </div>

                {/* Navigation - CENTER (Desktop) + Fullscreen (Mobile) */}
                <div className={`nav-center-wrapper ${isMenuOpen ? 'active' : ''}`}>
                    <ul className="nav-links">
                        <li><a href="/">{t('footer.links.home')}</a></li>
                        <li>
                            <a href="/#speisekarte" onClick={() => setIsMenuOpen(false)}>
                                {t('navbar.menu')}
                            </a>
                        </li>
                        <li>
                            <a href="/#ueberuns" onClick={() => setIsMenuOpen(false)}>
                                {t('navbar.about')}
                            </a>
                        </li>
                        <li>
                            <a href="/#ReservationForm" onClick={() => setIsMenuOpen(false)}>
                                {t('navbar.TableReservation')}
                            </a>
                        </li>
                        <li>
                            <a href="/#galerie" onClick={() => setIsMenuOpen(false)}>
                                {t('navbar.gallery')}
                            </a>
                        </li>
                        <li>
                            <a href="/#kontakt" onClick={() => setIsMenuOpen(false)}>
                                {t('navbar.contact')}
                            </a>
                        </li>

                    </ul>

                    {/* Button INSIDE nav-center-wrapper for mobile */}
                    <div className="mobile-button-wrapper">
                        <Link to="/bestellen" className="order-button" onClick={() => setIsMenuOpen(false)}>
                            {t('navbar.order')}
                        </Link>
                    </div>
                </div>
                <div className="bttn">
                    {/* Button - FAR RIGHT (Desktop only) */}
                    <div className="nav-button-wrapper">
                        <a href="/#Bestellen" className="order-button">{t('navbar.order')}</a>
                    </div>

                    <div className="nav-language-wrapper">
                        <LanguageSwitcher />
                    </div>
                </div>
            </div>
        </nav>
    );
}
